import { Configuration } from 'swagger/configuration';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const API_CLIENT_HEADERS = {
  'x-api-client': 'js-api-lib',
  'x-appversion': 1,
  'x-version': 1,
  'x-client': 'AUTH_SPA',
  authorization: 'Basic Y2FwdGFpbjpwaWNhcmQ=',
};

if (publicRuntimeConfig.NODE_ENV === 'development' && !!publicRuntimeConfig.DEV_USER_PUBLIC_ID) {
  API_CLIENT_HEADERS['x-dev-public-id'] = publicRuntimeConfig.DEV_USER_PUBLIC_ID;
}

export default new Configuration({
  basePath: publicRuntimeConfig.API_HOST,
  baseOptions: {
    headers: {
      ...API_CLIENT_HEADERS,
    },
  },
});
